/* RESPONSIBLE TEAM: team-tickets-1 */
export const VALID_ACTION_TYPES = ['read', 'change', 'delete'];

export const AWAY_MODE_KEY = 'can_teammates__away_mode__change';
export const REPORTS_DELETE_KEY = 'can_reporting__reports__delete';
